/**
 * Created by Bart Decorte
 * Date: 2019-07-17
 * Time: 10:52
 */
import Column from './Column';
import PlacePicker from '../utils/PlacePicker';

class CoordinatesColumn extends Column {
  constructor(params) {
    super(params);
    this.init();
  }

  init() {
    if (typeof google !== typeof undefined) {
      let $elements = this.$root.find('.js-coordinates');

      for (let i = 0; i < $elements.length; i++) {
        let $element = $($elements[i]);
        new PlacePicker({
          $root: $element,
        });
      }
    }
  }
}

export default CoordinatesColumn;



// WEBPACK FOOTER //
// ./resources/assets/js/columns/CoordinatesColumn.js